"use strict";
var $ = require("../internals/export");
var fails = require("../internals/fails");
var $imul = Math.imul;
var FORCED = fails(function() {
  return $imul(4294967295, 5) !== -5 || $imul.length !== 2;
});
$({ target: "Math", stat: true, forced: FORCED }, {
  imul: function imul(x, y) {
    var UINT16 = 65535;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});
